import Route from 'mewe/routes/route';
import { inject as service } from '@ember/service';

export default class AppPageRoute extends Route {
  @service router;

  model(params) {
    return params;
  }

  redirect(model) {
    this.router.transitionTo('app.publicid.feed', model.url_id);
  }
}
